import { StartTrainingModal } from 'modules/trainings/components/StartTrainingModal'

const StartTraining = () => {
  return <StartTrainingModal status="active" />
}

export default StartTraining
